import request from "../../request";

/**
 *  新增合作院校
 */
export function insertSchool(item) {
    return request({
        url: 'sys/PointsRule/insertPointsRule',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 *  更新合作院校
 */
export function updateSchool(item) {
    return request({
        url: 'sys/PointsRule/insertPointsRule',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}
/**
 * 删除合作院校
 */
export function deleteSchool(id) {
    return request({
        url: 'sys/PointsRule/deletePointsRule',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: id,
    })
}

/**
 *  合作院校列表
 */
export function selectSchoolPage(query) {
    return request({
        url: 'sys/PointsRule/GetPointsRuleByPage',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: query
    })
}
